import { render } from "./SuggestionStats.vue?vue&type=template&id=258c43a8&scoped=true"
import script from "./SuggestionStats.vue?vue&type=script&lang=js"
export * from "./SuggestionStats.vue?vue&type=script&lang=js"

import "./SuggestionStats.vue?vue&type=style&index=0&id=258c43a8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258c43a8"]])

export default __exports__